module.exports = __webpack_public_path__ + "images/img-1ogXKca.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/managers/75.jpg
// module id = 2022
// module chunks = 0